import React from 'react'

import { useTab, useIsSelected } from '../hooks'

import styles from './Tabs.module.css'

const Tab = ({ path, label, icon, defaultPath }) => {
  const [iSelected, select] = useTab(path)
  const isDefaultPath = useIsSelected(defaultPath)

  return (
    <li
      className={
        iSelected || (defaultPath && isDefaultPath)
          ? styles.tabSelected
          : styles.tab
      }
      onClick={select}
    >
      {icon && <i className={icon}></i>}
      {label && <div className={styles.tabLabel}>{label}</div>}
    </li>
  )
}
export default Tab
